import { Injectable } from '@angular/core';

import * as _ from 'lodash';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from './../service';

import { Logger } from './../logger/logger.service';
const log = new Logger('@mycure/mc-services');

@Injectable({
  providedIn: 'root'
})

export class McClockService {

  constructor(
    private sdk: MycureSDK,
  ) {

  }

  async loadCurrentMonthSelfAttendance(organization: string, uid: string, filter: any) {
    let query: any = { 
      type: 'attendance', organization, uid,
      $populate: {
        member: {
          key: 'uid', service: 'org-members',
          method: 'findOne', idField: 'uid'
        }
      }
    };

    // if has filter
    if (filter && filter.start && filter.end) {
      let start = new Date(filter.start); start.setHours(0, 0, 0, 0);
      let end = new Date(filter.end); end.setHours(23, 59, 59, 0);
      query = {
        ...query,
        startAt: { $lte: end, $gte: start },
        $dateFields: ['startAt.$gte', 'startAt.$lte']
      };
    }

    const res = await this.sdk.clocks().find(query);
    let items = res.items;

    items = items.map((item: any) => {
      return {
        ..._.omit(item, ['$populated']),
        _member: item.$populated.member
      }
    })

    return items;
  }

  async loadCurrentMonthStaffAttendance(organization: string, filter: any) {
    let query: any = {
      type: 'attendance',
      organization,
      $populate: {
        member: {
          key: 'uid', service: 'org-members',
          method: 'findOne', idField: 'uid'
        }
      }
    };

    // if has filter
    if (filter && filter.start && filter.end) {
      let start = new Date(filter.start); start.setHours(0, 0, 0, 0);
      let end = new Date(filter.end); end.setHours(23, 59, 59, 0);
      query = {
        ...query,
        startAt: { $lte: end, $gte: start },
        $dateFields: ['startAt.$gte', 'startAt.$lte']
      };
    }
    
    const res = await this.sdk.clocks().find(query);
    let items = res.items;

    items = items.map((item: any) => {
      return {
        ..._.omit(item, ['$populated']),
        _member: item.$populated.member
      }
    })

    return items;
  }

  async loadCurrentMonthClinicAttendance(organization: string, filter: any) {
    let query: any = { type: 'opening', organization };

    // if has filter
    if (filter && filter.start && filter.end) {
      let start = new Date(filter.start); start.setHours(0, 0, 0, 0);
      let end = new Date(filter.end); end.setHours(23, 59, 59, 0);
      query = {
        ...query,
        startAt: { $lte: end, $gte: start },
        $dateFields: ['startAt.$gte', 'startAt.$lte']
      };
    }
    
    const res = await this.sdk.clocks().find(query);
    return res.items;
  }

  /**
   * Load staff attendance
   * @param membership 
   * @param uid 
   */
  loadStaffAttendance(organization: string, uid: string) {
    const query: any = { type: 'attendance', organization, uid };
    return this.sdk.clocks().find(query);
  }

  async loadStaffTodayAttendance(organization: string, uid: string) {
    let query: any = { type: 'attendance', organization, uid };

    let start = new Date();
    start.setHours(0, 0, 0, 0);

    let end = new Date();
    end.setHours(23, 59, 59, 0);

    // add opening query
    query = {
      ...query,
      startAt: { $lte: end, $gte: start },
      $dateFields: ['startAt.$gte', 'startAt.$lte'],
    };

    const attendance = await this.sdk.clocks().findOne(query);
    return { status: attendance ? 'in' : 'out', id: (attendance || {}).id };
  }

  async loadStaffLastAttendance(organization: string, uid: string) {
    let query: any = { type: 'attendance', organization, uid, endAt: { $exists: false } };
    const attendance = await this.sdk.clocks().findOne(query);
    return { status: attendance ? 'in' : 'out', id: (attendance || {}).id };
  }

  /**
   * Create a staff attendance
   * @param organization
   */
  async createStaffAttendance(organization: string, uid: string) {
    const query: any = { type: 'attendance', uid, organization, endAt: { $exists: false } };
    const existingAttendance: any = await this.sdk.clocks().findOne(query);

    const attendance1 = { end: true };
    const attendance2 = { type: 'attendance', organization };

    return existingAttendance
      ? this.sdk.clocks().update(existingAttendance.id, attendance1)
      : this.sdk.clocks().create(attendance2);

    // const { status, id } = await this.loadStaffTodayAttendance(organization, uid);
    // if (!status && !id) throw new Error('no attendance loaded');

    // const clockIn  = { type: 'attendance', organization };
    // const clockOut = { end: true };

    // log.debug('using status', status);

    // return status == 'out' 
    //   ? this.sdk.clocks().create(clockIn)
    //   : this.sdk.clocks().update(id, clockOut);
  }

  /**
   * Get recent attendance of an organization
   * @param organization 
   */
  loadClinicAttendance(organization: string) {
    const query: any = { type: 'opening', organization, endAt: { $exists: false } };
    return this.sdk.clocks().findOne(query);
  }

  /**
   * Create an organization attendance
   * @param organization 
   */
  async createClinicAttendance(organization: string, forceCloseClinic: boolean = false) {
    const query: any = { type: 'opening', organization, endAt: { $exists: false } };
    const existingAttendance: any = await this.sdk.clocks().findOne(query);

    if (existingAttendance) {
      // close clinic & update attendance
      await this.closeClinic(organization, existingAttendance.id, forceCloseClinic);
    } else {
      // create attendance
      const attendance = { type: 'opening', organization };
      await this.sdk.clocks().create(attendance);
    }
  }

  /**
   * Force close the clinic 
   * 
   * @param organization 
   */
  private async closeClinic(organization: string, attendanceId: string, forceCloseClinic: boolean = false) {
    try {
      const query: any = { $active: true, facility: organization };
      const res = await this.sdk.mf.encounters().find(query);

      // if has pending encounters and force close is disabled
      if (res.items.length != 0 && !forceCloseClinic) {
        throw new Error('Has pending encounters')
      }
      
      // if has active items, force end all items
      if (res.items.length != 0 && forceCloseClinic) {
        const ids: string[] = res.items.map((item: any) => item.id);
        const update: any = { finish: true, force: true, save: true };
        await this.sdk.mf.encounters().update({ id: { $in: ids } }, update);
      }

      // if has queue items, remove all queue items
      const remove: any = { organization };
      await this.sdk.queue.items().remove(remove);

      // update org id to 0.
      const update: any = { queue_lastNumber: 0 };
      await this.sdk.organizations().update(organization, update);

      // update attendance
      const attendance = { end: true };
      await this.sdk.clocks().update(attendanceId, attendance);
    } catch (error) {
      throw new Error(error);
    }
  }
}
